/*
 * Copyright (c) 2022 Robert J Whelton. All rights reserved.
 */

import * as React from 'react'
import FaceIcon from '@mui/icons-material/Face'
import LogoutIcon from '@mui/icons-material/Logout'
import SettingsIcon from "@mui/icons-material/Settings";

import {ToggleFunctionType} from "../layouts/Layout"
import MenuDrawer from "./MenuDrawer"


interface SettingsMenuProps {
  open: boolean
  toggleDrawer: ToggleFunctionType
}

export const drawerWidthFactor = 0.2 //'20%'

const SettingsDrawer: React.FC<SettingsMenuProps> = ({open, toggleDrawer}) => {
  return (
    <MenuDrawer
      anchor="right"
      open={open}
      toggleDrawer={toggleDrawer}
      items={[
        {text: 'Profile', page: 'private/profile', icon: <FaceIcon/>, divider: false},
        {text: 'Settings', page: 'private/settings', icon: <SettingsIcon/>, divider: false},
        {text: 'Logout', icon: <LogoutIcon/>, divider: true},
      ]}
    />
  )
}

export default SettingsDrawer
